//API(s)
export const LOCAL_BASE_URL_API = 'http://127.0.0.1:5000/';

//TYPOGRAPHY
export const JBFS_ORANGE_BASE = '#FF6600';

//END POINTS - MASTER DATA
//PRODUCT CATEGORY
export const ALL_PRODUCT_CATEGORY = LOCAL_BASE_URL_API + 'product_categories';
export const POST_PUT_PRODUCT_CATEGORY = LOCAL_BASE_URL_API + 'product_category';
export const DELETE_GET_PRODUCT_CATEGORY = LOCAL_BASE_URL_API + 'product_category/';

export const ALL_PRODUCT_BRAND = LOCAL_BASE_URL_API + 'product_brands';
export const POST_PUT_PRODUCT_BRAND = LOCAL_BASE_URL_API + 'product_brand';
export const DELETE_GET_PRODUCT_BRAND = LOCAL_BASE_URL_API + 'product_brand/';

export const ALL_PRODUCT_SUB_CATEGORY = LOCAL_BASE_URL_API + 'product_sub_categories';
export const POST_PUT_PRODUCT_SUB_CATEGORY = LOCAL_BASE_URL_API + 'product_sub_category';
export const DELETE_GET_PRODUCT_SUB_CATEGORY = LOCAL_BASE_URL_API + 'product_sub_category/';

export const REGEX_EMAIL_PATTERN = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const IS_LOADING = 'IS_LOADING';
export const PAGE_SETTINGS = 'PAGE_SETTINGS';
export const IS_ERROR = 'IS_ERROR';
export const FETCH_INIT_DATA = 'FETCH_INIT_DATA';


export const FETCH_RELATED_MENU_IDEAS = 'FETCH_RELATED_MENU_IDEAS';

export const LANG_EN = 'en-us';
export const LANG_ID = 'id-id';

export const PRODUCT_LIST_REQUEST = 'PRODUCT_LIST_REQUEST'
export const PRODUCT_LIST_SUCCESS = 'PRODUCT_LIST_SUCCESS'
export const PRODUCT_LIST_FAIL = 'PRODUCT_LIST_FAIL'
